var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg005AKiKamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 451.667,
    height: 451.667,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -1,
    width: 314.424768,
    height: 314.424768,
    id: "canvas_background",
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("ellipse", {
    ry: 213.823302,
    rx: 213.74094,
    id: "svg_5",
    cy: 226.9585,
    cx: 223.877281,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#f2f2f2",
    transform: "rotate(-0.13552172482013702 223.87727355954502,226.95851135253383) ",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_3"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    d: "m175.336179,257.920519c-0.179308,-4.697887 -3.962265,-8.380354 -8.520446,-8.380354c-0.112501,0 -0.22501,0.001801 -0.339271,0.005393c-4.707605,0.188707 -8.374542,4.243195 -8.191724,9.057895l0.820935,21.465771l-27.275277,-7.506912c-4.612672,7.320005 -12.649703,12.181426 -21.783652,12.181426c-11.146716,0 -20.670908,-7.237325 -24.316766,-17.355569l-14.766192,-4.649358l11.106292,-8.675097c3.744284,-2.924037 4.459747,-8.398316 1.59967,-12.226354c-2.860069,-3.828037 -8.214579,-4.561293 -11.958855,-1.637247l-24.271055,18.958674c-5.502174,4.297109 -3.953476,13.182467 2.668462,15.26723l39.344874,12.386303l0,53.385855l-25.417186,15.02461c-2.853048,1.687568 -4.784959,4.627785 -5.227934,7.968789l-7.012198,52.648998c-0.87014,6.543613 4.102899,12.375526 10.580685,12.375526c5.250798,0 9.826556,-3.966414 10.554319,-9.433509l6.305515,-47.356241c32.652626,-19.307339 30.270703,-17.878562 30.748849,-18.187675l6.592045,0l-12.435241,30.144451c-1.912575,4.633187 -0.474627,10.003222 3.477082,12.995561l39.197218,29.693351c4.711123,3.571047 11.396342,2.589768 14.917375,-2.26806c3.506975,-4.838073 2.51201,-11.667435 -2.21845,-15.251051l-32.46277,-24.592903l10.570128,-25.624494c0.687338,-1.667797 0.936946,-3.411088 0.805109,-5.096856l0.054499,0l0,-60.781346l27.38426,7.537461c5.53381,1.525827 10.969168,-2.873725 10.744166,-8.763152l-1.274466,-33.311118l0,0zm0,0",
    id: "svg_1",
    fill: "#193351"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    d: "m129.222444,259.12072c0,10.831727 -8.587253,19.61286 -19.181996,19.61286c-10.596502,0 -19.183747,-8.781132 -19.183747,-19.61286c0,-10.831736 8.587245,-19.612851 19.183747,-19.612851c10.594743,0 19.181996,8.781115 19.181996,19.612851zm0,0",
    id: "svg_2",
    fill: "#193351"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_20"
  }, /*#__PURE__*/React.createElement("ellipse", {
    stroke: "null",
    fill: "#e3e8ee",
    strokeWidth: "null",
    strokeOpacity: "null",
    cx: 345.547395,
    cy: 210.799555,
    id: "svg_4",
    rx: 21.13771,
    ry: 20.776741
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    fill: "#e3e8ee",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 345.296235,
    y: -174.757666,
    width: 84.925351,
    height: 36.112312,
    id: "svg_6",
    transform: "matrix(0.6736622733597876,0.011415322044221228,-0.011758818721185752,0.6539833619161967,131.44624861001546,304.1645338456164) "
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    fill: "#e3e8ee",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 323.68916,
    y: -229.506577,
    width: 297.956273,
    height: 100.232101,
    id: "svg_7",
    transform: "matrix(0.5834975117980332,-0.3270414909612327,0.3368824455080713,0.5664524785279331,55.22092397149055,413.8297065850557) "
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    fill: "#777f8e",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 343.780665,
    y: -332.452714,
    width: 270.721591,
    height: 141.745992,
    id: "svg_8",
    transform: "matrix(0.5892880516613456,-0.31710572207542226,0.32664770094885076,0.5720738660938895,83.26311942443562,407.66568841887903) "
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    fill: "#777f8e",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 235.408732,
    y: -260.075553,
    width: 199.426291,
    height: 42.192041,
    id: "svg_9",
    transform: "matrix(0.5892880516613456,-0.31710572207542226,0.32664770094885076,0.5720738660938895,63.91337413751728,364.1856617586886) "
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    fill: "#ff0033",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 514.251381,
    y: 538.624207,
    width: 64.999251,
    height: 25.791537,
    id: "svg_10",
    transform: "matrix(-0.31631345633561375,-0.5775209944184301,0.5948990886755604,-0.3070733597147954,3.9953639707973707,682.6210668110972) "
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    fill: "#777f8e",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 188.129184,
    y: 726.165585,
    width: 148.20726,
    height: 70.051135,
    id: "svg_11",
    transform: "matrix(-0.6590415116061139,-0.13599149870662172,0.14008359770480955,-0.6397896994482727,254.84183914473678,672.8030612871114) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "null",
    fill: "#e3e8ee",
    strokeWidth: "null",
    strokeOpacity: "null",
    cx: 326.842858,
    cy: 176.540227,
    id: "svg_12",
    rx: 12.154183,
    ry: 12.568648
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    d: "m444.479147,148.638832l-10.059354,0c-9.261576,0 -16.796297,7.314631 -16.796297,16.305654l0,23.871433l-45.161108,0c-5.057263,-6.428344 -12.643838,-10.87935 -21.305131,-11.948799l-9.471769,-15.92628l38.979363,-21.847025c3.222607,-1.805927 4.326858,-5.806267 2.465936,-8.934777l-9.203601,-15.476268l15.941923,-8.935388c3.222607,-1.805927 4.326934,-5.806322 2.466011,-8.934788l-37.719433,-63.42449c-5.669703,-9.532556 -16.278822,-15.454665 -27.687649,-15.454665c-5.563248,0 -11.049757,1.427197 -15.866509,4.126645l-201.443567,112.905832c-3.222607,1.805917 -4.326934,5.806322 -2.465958,8.934766l12.572412,21.140595c0.893423,1.502417 2.364914,2.598707 4.0911,3.047376l18.641753,4.849409l-7.693061,4.311029c-1.547638,0.867312 -2.676873,2.295819 -3.139088,3.971589c-0.462884,1.675771 -0.220281,3.461425 0.673131,4.963199l25.144866,42.27928c1.248494,2.098297 3.512363,3.271684 5.84158,3.271684c1.142697,0 2.30156,-0.282572 3.362085,-0.877099l15.943949,-8.936719l9.204959,15.478199c0.893423,1.502417 2.364914,2.598696 4.0911,3.047376c0.57407,0.149153 1.159575,0.223031 1.743701,0.223031c1.172379,0 2.335975,-0.297607 3.368865,-0.876456l107.237771,-60.105659l9.468384,15.919701c-1.593412,3.679896 -2.4761,7.718227 -2.4761,11.954025c0,17.067653 14.303416,30.952526 31.883954,30.952526c10.3268,0 19.517586,-4.794439 25.348366,-12.206472l45.161108,0l0,23.871379c0,8.99039 7.534732,16.30501 16.796308,16.30501l10.059279,0c3.721209,0 6.737665,-2.928316 6.737665,-6.540825l0,-104.763157c0.000657,-3.61252 -3.016456,-6.540869 -6.736943,-6.540869zm-314.480495,7.515458l-7.808224,-13.130096l195.608766,-109.635424c2.770544,-1.552771 5.927772,-2.373636 9.128844,-2.373636c6.609633,0 12.74763,3.415599 16.017401,8.913839l34.350536,57.760065l-149.636407,83.868528l-97.660917,-25.403277zm35.745934,60.103674l-18.407255,-30.949918l10.109871,-5.666301l18.406576,30.949874l-10.109192,5.666345zm34.352573,8.936054l-26.214833,-44.081236c-0.000668,-0.000666 0,0 -0.000668,-0.000666l52.986911,13.782811c0.258726,0.067419 0.519458,0.113834 0.781514,0.150484c0.078195,0.011129 0.156335,0.017643 0.235187,0.026154c0.193347,0.020273 0.386036,0.032678 0.580095,0.036628c0.048523,0.000666 0.097703,0.009143 0.146894,0.009143c0.030319,0 0.05998,-0.005226 0.090309,-0.005881c0.258716,-0.003262 0.516084,-0.017021 0.772084,-0.049034c0.005389,-0.000655 0.010789,-0.000655 0.015531,-0.001309c0.260742,-0.033388 0.518779,-0.085716 0.773463,-0.149175c0.07481,-0.018265 0.148909,-0.040534 0.223019,-0.061461c0.188658,-0.052984 0.374633,-0.113801 0.557924,-0.18314c0.072719,-0.027485 0.146172,-0.052995 0.217597,-0.083065c0.244553,-0.102061 0.485787,-0.213222 0.718215,-0.343412l130.276515,-73.01854l5.834747,9.811887l-167.994504,94.159811zm119.810883,-52.046661l10.107834,-5.665701l6.481644,10.898357c-3.73466,1.284602 -7.147952,3.226578 -10.098381,5.680736l-6.491085,-10.913392l-0.000011,0zm45.576881,35.503607c-0.005389,0.085706 -0.013516,0.170746 -0.019551,0.255753c-0.022267,0.283216 -0.05057,0.566432 -0.086278,0.847672c-0.011446,0.088302 -0.022203,0.176648 -0.034996,0.264274c-0.04516,0.319189 -0.098382,0.637069 -0.161735,0.953018c-0.007415,0.035952 -0.012804,0.071936 -0.019519,0.107898c-0.072094,0.3519 -0.156982,0.700516 -0.251322,1.04719c-0.022893,0.086306 -0.050549,0.172022 -0.07481,0.258372c-0.070715,0.243303 -0.146182,0.485996 -0.227039,0.726681c-0.043791,0.132154 -0.090309,0.263565 -0.137452,0.394388c-0.06871,0.189021 -0.142151,0.374813 -0.216918,0.561216c-0.060691,0.148498 -0.117286,0.298262 -0.180597,0.444109c-0.024261,0.056912 -0.0532,0.11187 -0.078119,0.168116c-0.186007,0.414038 -0.387481,0.819588 -0.603731,1.216616c-0.049827,0.091532 -0.099718,0.18314 -0.151582,0.274018c-3.138431,5.516548 -9.190193,9.262521 -16.127251,9.262521c-10.150234,0 -18.408581,-8.017144 -18.408581,-17.870886s8.258347,-17.870831 18.408581,-17.870831c6.935743,0 12.986158,3.744587 16.124524,9.259204c0.053233,0.093507 0.104482,0.188367 0.155678,0.283216c0.105776,0.194226 0.211551,0.388496 0.309922,0.586671c0.129336,0.262299 0.254706,0.526563 0.370559,0.794765c0.06331,0.143861 0.119259,0.291039 0.17787,0.436897c0.076125,0.189021 0.151593,0.378076 0.220346,0.569028c0.046442,0.129546 0.092303,0.259703 0.136083,0.390525c0.081525,0.242627 0.157639,0.486629 0.228419,0.732573c0.024218,0.084385 0.051206,0.168105 0.074099,0.253091c0.09434,0.347339 0.179239,0.696621 0.251322,1.049165c0.007405,0.034653 0.012804,0.070016 0.01953,0.104658c0.063342,0.316549 0.116564,0.635749 0.161724,0.955604c0.012794,0.087026 0.02355,0.175306 0.034996,0.262943c0.035697,0.281906 0.064,0.564478 0.086267,0.848349c0.006769,0.08504 0.014173,0.169425 0.019562,0.255087c0.022903,0.362375 0.037023,0.72475 0.037023,1.089045s-0.014119,0.726692 -0.037023,1.089056zm52.138573,4.575969l-39.163925,0l0,-0.000644c0.022914,-0.122345 0.03976,-0.245278 0.061359,-0.367612c0.051842,-0.291715 0.103049,-0.58342 0.146829,-0.877765c0.030319,-0.203413 0.05458,-0.407492 0.08021,-0.610894c0.035708,-0.281295 0.072752,-0.562536 0.100376,-0.846429c0.024272,-0.245933 0.040418,-0.493143 0.057964,-0.740396c0.018172,-0.244613 0.041064,-0.487283 0.052521,-0.733227c0.019573,-0.403585 0.027635,-0.807815 0.031687,-1.212644c0.000679,-0.092263 0.007405,-0.183151 0.007405,-0.27608c0,-0.092852 -0.006725,-0.183795 -0.007405,-0.276004c-0.004053,-0.404906 -0.011468,-0.80908 -0.031687,-1.212644c-0.012114,-0.245944 -0.034371,-0.489291 -0.052521,-0.733904c-0.018193,-0.246588 -0.033692,-0.493175 -0.057964,-0.739119c-0.027635,-0.284503 -0.065379,-0.565788 -0.100376,-0.847705c-0.026288,-0.202737 -0.049891,-0.40616 -0.08021,-0.608286c-0.043069,-0.295622 -0.094987,-0.588668 -0.146829,-0.881038c-0.021599,-0.121657 -0.038445,-0.244002 -0.061359,-0.364993l39.163925,0l0,11.329384zm20.117975,40.175712l-3.321679,0c-1.800296,0 -3.320967,-1.475609 -3.320967,-3.223316l0,-85.235486c0,-1.747728 1.520671,-3.223992 3.320967,-3.223992l3.321679,0l0,91.682794z",
    id: "svg_13",
    fill: "#193351"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    d: "m286.035921,94.393133c-1.859564,-3.128467 -5.980347,-4.202476 -9.202976,-2.395894l-0.149556,0.08372c-3.222618,1.805262 -4.328249,5.805645 -2.467962,8.934112c1.247782,2.098974 3.512956,3.272393 5.842162,3.272393c1.142061,0 2.300256,-0.282561 3.360781,-0.876488l0.149567,-0.08372c3.222618,-1.805273 4.32826,-5.805667 2.467984,-8.934123z",
    id: "svg_14",
    fill: "#e3e8ee"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    d: "m331.746148,68.768112c-1.860265,-3.127801 -5.978967,-4.200501 -9.20359,-2.393908l-27.789459,15.575689c-3.222629,1.805906 -4.326891,5.806256 -2.465958,8.934766c1.248483,2.097643 3.51232,3.271062 5.841515,3.271062c1.142707,0 2.300914,-0.282594 3.362085,-0.877143l27.789459,-15.575689c3.222629,-1.805917 4.326891,-5.806256 2.465947,-8.934777z",
    id: "svg_15",
    fill: "#e3e8ee"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    d: "m344.618468,90.411735c-1.859618,-3.12911 -5.9797,-4.202476 -9.202943,-2.395894l-0.14962,0.083731c-3.222629,1.805262 -4.328249,5.80559 -2.467984,8.934112c1.247836,2.099563 3.513032,3.272349 5.842227,3.272349c1.142007,0 2.300181,-0.282572 3.360738,-0.876434l0.149556,-0.083731c3.222629,-1.805262 4.328249,-5.805656 2.468027,-8.934133z",
    id: "svg_16",
    fill: "#e3e8ee"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    d: "m326.544017,100.53825c-1.860922,-3.127801 -5.980347,-4.200501 -9.20359,-2.393963l-27.788758,15.575667c-3.223329,1.805927 -4.326945,5.805667 -2.466022,8.934133c1.248494,2.098963 3.512374,3.271717 5.841569,3.271717c1.142664,0 2.30155,-0.28255 3.362064,-0.877099l27.78878,-15.575678c3.222629,-1.806593 4.326891,-5.806322 2.465958,-8.934777z",
    id: "svg_17",
    fill: "#e3e8ee"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    fill: "#193351",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 439.777697,
    y: -227.148188,
    width: 16.208271,
    height: 146.601513,
    id: "svg_18",
    transform: "matrix(0.6736622733597876,0.011415322044221228,-0.011758818721185752,0.6539833619161967,131.48623652489727,303.50718460707265) "
  }), /*#__PURE__*/React.createElement("text", {
    stroke: "null",
    transform: "matrix(4.67381931847615,-2.6165201513461938,2.808313968922551,4.354620803042145,-261.1254576569488,306.5783765829205) ",
    xmlSpace: "preserve",
    textAnchor: "start",
    fontFamily: "Helvetica, Arial, sans-serif",
    fontSize: 14,
    id: "svg_19",
    y: 21.918132,
    x: 88.727599,
    strokeOpacity: "null",
    strokeWidth: 0,
    fill: "#e3e8ee"
  }, "KI")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg005AKiKamera);
export default __webpack_public_path__ + "static/media/005a-KI-Kamera.380da984a594ed939f803d6aa1d43ef4.svg";
export { ForwardRef as ReactComponent };